var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('editor',{model:{value:(_vm.new_value),callback:function ($$v) {_vm.new_value=$$v},expression:"new_value"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }